module.exports = __webpack_public_path__ + "fonts/GillSansProCyrillic-Light.44c40d1f.woff";